// extracted by mini-css-extract-plugin
export default {"wrapper":"MinMaxSidebar_wrapper__mj1Ye","container":"MinMaxSidebar_container__BtxIa","title":"MinMaxSidebar_title__o0unW"};